import React from 'react';

const SchemaBrainSpineSurgery = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What conditions are treated under Brain & Spine Surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Brain & spine surgery covers conditions such as brain tumors, stroke, head injuries, slip disc, spinal stenosis, scoliosis, spine fractures, and nerve-related disorders. Early diagnosis and expert care are essential for effective treatment."
        }
      },
      {
        "@type": "Question",
        "name": "When should I consult a neurosurgeon or spine specialist in Patna?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You should consult a specialist if you experience persistent back or neck pain, numbness, weakness in limbs, frequent headaches, loss of balance, or any head/spine injury."
        }
      },
      {
        "@type": "Question",
        "name": "Is spine surgery always required for back pain?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No, most spine problems can be treated with medication, physiotherapy, and lifestyle changes. Surgery is recommended only in severe cases where non-surgical treatments do not provide relief."
        }
      },
      {
        "@type": "Question",
        "name": "What is minimally invasive spine surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Minimally invasive spine surgery is an advanced technique that uses small incisions, resulting in less pain, reduced blood loss, shorter hospital stay, and faster recovery compared to traditional surgery."
        }
      },
      {
        "@type": "Question",
        "name": "How risky is brain surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Brain surgery is a complex procedure, but with modern technology, experienced neurosurgeons, and advanced monitoring systems, the risks are significantly reduced and outcomes are highly improved."
        }
      },
      {
        "@type": "Question",
        "name": "How long does recovery take after spine surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Recovery time varies depending on the type of surgery and patient condition. Minimally invasive procedures may allow recovery within a few weeks, while complex surgeries may take longer."
        }
      },
      {
        "@type": "Question",
        "name": "What are the symptoms of a slipped disc?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Common symptoms include lower back pain, pain radiating to legs, numbness, tingling sensation, and muscle weakness. Early treatment can prevent complications."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide emergency brain and spine care in Patna?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, 24×7 emergency services are available for stroke, head injuries, spine trauma, and other critical neurological conditions requiring immediate medical attention."
        }
      },
      {
        "@type": "Question",
        "name": "What diagnostic tests are used before brain or spine surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Doctors may recommend MRI, CT scans, X-rays, and neurological assessments to accurately diagnose the condition and plan the treatment."
        }
      },
      {
        "@type": "Question",
        "name": "How do I choose the best hospital for brain & spine surgery in Patna?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Look for experienced neurosurgeons, advanced technology, emergency support, patient reviews, and a hospital that offers complete care including diagnosis, surgery, and rehabilitation."
        }
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
};

export default SchemaBrainSpineSurgery;